<template>
  <memlist-card>

    <div class="d-flex justify-end" v-if="showNewButton">
      <memlist-icon-button
        class="mb-2"
        icon="menu-icon flaticon2-plus"
        :text="isExpense ? 'Skapa ny utgift' : 'Skapa ny intäkt'"
        variant="primary"
        @click="onCreateNewRowClicked"
      />
    </div>

    <table class="table table-head-custom table-vertical-center table-head-bg table-borderless">
      <thead>
        <tr class="text-left">
          <th v-if="!isExpense">Sökt bidrag</th>
          <th style="min-width: 110px">{{ isExpense ? 'Utgiftstyp' : 'Intäktstyp' }}</th>
          <th style="min-width: 110px">Summa</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(item, i) in local_items">
          <GrantBudgetTableRow
            v-bind:key="i"
            :row="item"
            :isDisabled="isDisabled || item.apply"
            :isExpense="isExpense"
            @delete_row_clicked="delete_row_clicked"
            @onRowChanged="onRowChanged"
          />
        </template>
      </tbody>
    </table>
  </memlist-card>
</template>

<script>
import axios from 'axios';
import GrantBudgetTableRow from '@/view/pages/ml/grant/GrantBudgetTableRow.vue';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

export default {
  name: 'grant-budget-table',
  props: ['items','showNewButton','isDisabled','title','isExpense'],
  emits: ['createRowClicked', 'delete_row_clicked', 'onRowChanged'],
  mixins: [ toasts ],
  components: {
    GrantBudgetTableRow
  },
  watch: {
    items: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        this.local_items = { ...this.items };
      },
      immediate: true
    },
  },

  mounted() {
  
  },
  methods: {
    onCreateNewRowClicked() {
      this.$emit('createRowClicked');
    },
    delete_row_clicked(id) {
      this.$emit('delete_row_clicked', id);
    },
    onRowChanged(row) {
      this.$emit('onRowChanged', row);
    }
  },
  data() {
    return {
      local_items: [],
    };
  }
};
</script>
